// Glass-i — HR Branches API client (Stage HRMS-2).

import client from '../../../../api/client';

const BASE = '/api/erp/hrms/branches';

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined ? resp.data.data : resp && resp.data;
}

export const hrBranchesApi = {
  list:     (params = {}) => client.get(BASE, { params }).then(unwrap),
  lookups:  (params = {}) => client.get(`${BASE}/lookups`, { params }).then(unwrap),
  create:   (payload)     => client.post(BASE, payload).then(unwrap),
  update:   (id, payload) => client.put(`${BASE}/${encodeURIComponent(id)}`, payload).then(unwrap),
  remove:   (id)          => client.delete(`${BASE}/${encodeURIComponent(id)}`).then(unwrap),
  bulkSave: (payload)     => client.post(`${BASE}/bulk-save`, payload).then(unwrap)
};

export default hrBranchesApi;
